import React from 'react';
import { Card, CardBody } from 'reactstrap';
import Skeleton from 'react-loading-skeleton';
import { useSelector } from 'react-redux';
import Loader from '../../../components/common/Loader';

const ProfileAnalysis = ({ audienceAnalysis }) => {
    const loading = useSelector(state => state.audienceAnalysis.loading);

    return (
        <div>
            <Card className="ribbon-box border mb-lg-0 profile-card">
                {loading ? (
                    <CardBody className="d-flex justify-content-center align-items-center" style={{ height: '100%' }}>
                        <Loader />
                    </CardBody>
                ) : (
                    <CardBody className="p-4 d-flex justify-content-start">
                        <div className="ribbon ribbon-secondary round-shape">Veloxity AI - Profile Analysis</div>
                        <div className="profile-analysis-container" style={{ overflowY: 'auto', maxHeight: '170px' }}>
                            <p className="profile-analysis-text">
                                {audienceAnalysis ?
                                    audienceAnalysis.message
                                    : <Skeleton count={4} />}
                            </p>
                        </div>
                    </CardBody>
                )
                }
            </Card>
        </div>
    );
}

export default ProfileAnalysis;
